import React from 'react'
import { formatPrice } from '../../../utils/formatPrice';

const OfferCard = ({offer ,product}) => {
  const currency_factor=product.currency_factor
      const offerData = [
    { label: "السعر قبل الخصم", value: formatPrice(currency_factor, product.price) },
    { label: "السعر بعد الخصم", value:  formatPrice( currency_factor,   offer.sale_price)  },
    { label: "نسبة الخصم", value:  formatPrice(currency_factor ,  offer.discount_amount)    },
    { label: "التاريخ", value: offer.start_date  },
     { label: "التاريخ", value:  offer.end_date  },
      
  ];
  
  return (
    <div className="card rounded-3">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="font16"> عرض خاص علي المنتج</h4>
          {/* <button className="btn btn-primary">تعديل العرض</button> */}
        </div>

        <div className="row mt-2 g-3">
          {offerData.map((item, index) => (
            <div className=" col-4 " key={index}>
              <div className="bg-neutral-100 rounded-3 p-2 ">
                <h5 className="desc m-0 text-center">{item.label}</h5>
                <span className="font14 font700 d-block text-center">
                  {item.value} 
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OfferCard